import React from 'react';

import { DetailBackLink, DetailError } from '../pages/shared/detail/DetailPageKit';

/**
 * AccessDenied
 *
 * Terminal route for URLs that belong to an application the signed-in user's
 * customer is not subscribed to.
 *
 * Every application route in AuthorizedRoutes is conditional on the customer's
 * application list, so an unavailable URL previously matched no route at all and
 * fell through to the (intentionally empty) application shell — the user saw a
 * blank page with no explanation and no way back.  Mounting this component as
 * the last route of each guarded namespace keeps that from happening.
 */
const AccessDenied = () => (
	<div className="cg-detail cg-font-body">
		<DetailError message="You do not have access to this page. The application that owns it is not enabled for your account's customer.">
			<DetailBackLink to="/all-projects" label="Back to All Projects" />
		</DetailError>
	</div>
);

export default AccessDenied;
